import { WeightsRule } from '../../../types/planRules';

/** The free plan. Every user without an active premium subscription follows its rules. */
export const FREE_PLAN_NAME = 'Basic';

export const WEIGHTS_LABELS: Record<WeightsRule, string> = {
  TEMPLATE: 'Keep the template weights',
  EQUAL: 'Equal split only',
  ANY: 'Any weights',
};

export const WEIGHTS_SHORT_LABELS: Record<WeightsRule, string> = {
  TEMPLATE: 'Template only',
  EQUAL: 'Equal split',
  ANY: 'Any',
};

/** allowed_fund_geo_category_id: null = any, 1 = Global, 2 = Saudi. Key 'null' = any region. */
export const GEO_LABELS: Record<string, string> = {
  null: 'Any region',
  1: 'Global only',
  2: 'Saudi only',
};

/** Stricter rules make some existing holders unable to add money. */
export const WEIGHTS_STRICTNESS: Record<WeightsRule, number> = { ANY: 0, TEMPLATE: 1, EQUAL: 1 };

export const HISTORY_PAGE_SIZE = 25;

/** History filter: plans_change_history.table_name → label. */
export const HISTORY_TABLE_LABELS: Record<string, string> = {
  plans: 'Plan totals',
  plans_portfolio_feature: 'Product groups',
  plans_portfolio_feature_product_type: 'Products in groups',
  plans_portfolio_feature_details: 'Group rules',
  plans_service_feature_details: 'Services',
};

/** History column → label. */
export const HISTORY_COLUMN_LABELS: Record<string, string> = {
  portfolioLimit: 'Portfolios',
  recommendationLimit: 'Saved recommendations',
  recommendationCappedByPortfolios: 'Count recommendations as slots',
  managementFee: 'Management fee',
  roboAdvicePortfolioLimit: 'Robo Advice portfolios',
  roboAdviceWeightsRule: 'Robo Advice fund weights',
  // No longer editable (no grace since 2026-10-14) — kept so old history rows still show a label.
  managementFeeInGrace: 'Management fee in grace',
  maxFunds: 'Funds in one portfolio',
  weightsRule: 'Fund weights',
  allowedFundGeoCategoryId: 'Funds from',
  name: 'Name',
  active: 'Rules switched on',
  featureKey: 'Key',
  productTypeId: 'Product',
  plansPortfolioFeatureId: 'Moved to group',
  limit: 'Included',
};

/**
 * Publish refusals that protect users (madkhol-user plan-rules-admin.service.ts). A product with no rules is open to
 * everyone, so the server refuses a publish that would open one by mistake.
 */
export const PUBLISH_ERROR_MESSAGES: Record<string, string> = {
  PRODUCT_TYPE_LEFT_WITHOUT_GROUP:
    'Not published. A product would end up in no group, which opens it to every user with no limits. Move it to another group instead.',
  BASIC_RULE_REMOVED_FROM_ACTIVE_GROUP: `Not published. A product would lose its ${FREE_PLAN_NAME} rules while its group is on, which opens it to every ${FREE_PLAN_NAME} user. Keep the ${FREE_PLAN_NAME} row, or switch the group off if you mean to open it.`,
  UNKNOWN_PRODUCT_TYPE:
    'Not published. One of the products added to a group does not exist. Reload the page and pick it again.',
};
